import { useMutation } from '@tanstack/react-query';
import { downloadNfseLoteApi } from '../api/DownloadNfseLoteApi';
import type { DownloadNfseLotePayload, DownloadNfseLoteResponse } from '../types';

export function useDownloadNfseLote() {
  return useMutation<DownloadNfseLoteResponse, Error, DownloadNfseLotePayload>({
    mutationFn: downloadNfseLoteApi,
  });
}
